<template>
  <OmtGrid>
    <OmtRow>
      <OmtTypography
        as="h1-bold"
        mb="24px"
      >
        Protocolo {{ protocol }}
      </OmtTypography>
    </OmtRow>
    <OmtRow
      :mobileEnd="1"
      :desktopEnd="5"
      mb="16px"
    >
      <TextTile
        :title="'Assunto'"
        :description="detail.title"
      />
    </OmtRow>
    <OmtRow
      :mobileEnd="2"
      :desktopStart="6"
      mb="16px"
    >
      <TextTile
        :title="'Data da solicitação'"
        :description="detail.createdAt"
      />
    </OmtRow>

    <OmtRow
      :mobileStart="1"
      mb="16px"
    >
      <TextTile
        :title="'Beneficiário'"
        :description="detail.beneficiaryName"
      />
    </OmtRow>

    <OmtRow
      :mobileEnd="1"
      :desktopEnd="5"
      mb="16px"
    >
      <TextTile
        :title="'Código beneficiário'"
        :description="detail.beneficiaryCode"
      />
    </OmtRow>

    <OmtRow
      :mobileEnd="5"
      :desktopStart="6"
      mb="16px"
    >
      <CFlex direction="column">
        <OmtTypography
          as="p2"
          color="var(--colors-light-primary-gray2)"
        >
          Status
        </OmtTypography>
        <StatusTile
          :label="detail.statusDsc"
          :color="statusColor"
        />
      </CFlex>
    </OmtRow>

    <OmtRow
      v-if="hasPendency"
      :desktopEnd="12"
      backgroundColor="#F6F6F9"
      borderRadius="8px"
      w="100%"
    >
      <CFlex
        borderRadius="8px"
        flexDirection="Column"
      >
        <CFlex
          pl="10px"
          pt="16px"
          pb="14px"
          align-items="center"
        >
          <img
            :src="IconOmint"
            alt="Omint"
          />
          <OmtTypography as="p1-bold"> Para continuidade da análise, solicitamos: </OmtTypography>
        </CFlex>
        <CFlex
          pl="35px"
          pb="16px"
        >
          <ol>
            <li>O envio do pedido médico com a assinatura do médico solicitante.</li>
            <li>Data das sessões.</li>
          </ol>
        </CFlex>
      </CFlex>
    </OmtRow>

    <RequestResponseCard
      v-if="hasRequestContent"
      :description="detail.description"
      :createdAt="detail.doc.createdAt"
      :pictures="pictures"
      :responses="hasResponse"
    />

    <OmtRow
      v-if="hasPendency"
      justify-content="center"
    >
      <OmtButton
        height="40px"
        fontSize="14px"
        mt="20px"
        @click="modalPendencies = true"
      >
        Responder pendências
      </OmtButton>
    </OmtRow>

    <PendingResponseModal
      :reasons="pendencyReasons"
      :isOpen="modalPendencies"
      @close="closeModal"
      @submit="submit"
    />

    <SendPendency
      :isOpen="openModalSuccess"
      :protocol="detail.protocol"
      @close="closeModalSendPendency"
    />

    <Footer />
  </OmtGrid>
</template>
<script>
import Footer from "@/components/Molecules/Footer";
import TextTile from "@/components/Molecules/TextTile";
import PendingResponseModal from "@/components/Organisms/Sac/PendingResponseModal.vue";
import SendPendency from "@/components/Organisms/Sac/SendPendency.vue";
import StatusTile from "@/components/Organisms/Sac/StatusTile.vue";
import RequestResponseCard from "@/components/Organisms/Sac/RequestResponseCard.vue";
import { mapActions, mapState } from "vuex";
export default {
  name: "DetailOuvidoria",
  components: {
    TextTile,
    StatusTile,
    Footer,
    PendingResponseModal,
    SendPendency,
    RequestResponseCard
  },
  data() {
    return {
      detail: {},
      modalPendencies: false,
      openModalSuccess: false,
      pictures: []
    };
  },
  computed: {
    ...mapState("sac", ["complaints"]),
    protocol() {
      return this.$route.params.protocol ?? "";
    },
    statusColor() {
      switch (this.detail.statusCode) {
        case "F":
          return "var(--colors-light-support-success)";
        case "P":
          return "var(--colors-light-support-warning)";
        case "T":
          return "var(--colors-light-primary-gray2)";
        default:
          return "var(--colors-light-primary-dark-blue)";
      }
    },
    hasPendency() {
      return this.detail?.statusCode === "P" && this.detail?.pendency?.ticket > 0;
    },
    hasDoc() {
      const idDoc = this.detail?.doc?.id ?? 0;
      return idDoc > 0;
    },
    hasResponse() {
      const raw = this.detail?.doc?.resp;
      if (!raw) return [];
      const arr = Array.isArray(raw) ? raw : [raw];
      return arr.map(response => String(response).trim()).filter(response => response.length > 0);
    },
    pendencyReasons() {
      if (!this.hasPendency) return [];
      return this.detail?.pendency?.reasons ?? [];
    },
    IconOmint() {
      return process.env.VUE_APP_BASE_URL + "images/Group3305.png";
    },
    hasRequestContent() {
      const hasDescription = String(this.detail?.description ?? "").trim().length > 0;
      const hasPictures = (this.pictures?.length ?? 0) > 0;
      const hasResponses = (this.hasResponse?.length ?? 0) > 0;
      return !!(hasDescription || hasPictures || hasResponses || this.hasPendency);
    }
  },
  methods: {
    ...mapActions("sac", ["fetchComplaintDetail", "fetchProtocolDetailImage", "getDocumentUrl", "returnRequestTicket"]),
    async getDetail() {
      const detail = await this.fetchComplaintDetail({
        protocol: this.protocol
      });
      if (!detail) {
        this.$router.replace("/ouvidoria");
        return;
      }
      this.detail = detail;
      this.loadPictures();
    },
    loadPictures() {
      if (!this.detail?.pictures?.length) return;
      this.detail.pictures.forEach(p =>
        this.fetchProtocolDetailImage({ documento: p, original: false }).then(source =>
          this.pictures.push({
            id: p,
            source: source,
            loadModalImage: () => this.loadPicture(p)
          })
        )
      );
    },
    async loadPicture(id) {
      return await this.fetchProtocolDetailImage({ documento: id, original: true });
    },
    closeModal() {
      this.modalPendencies = false;
    },
    closeModalSendPendency() {
      this.openModalSuccess = false;
    },
    async submit({ pictures, obs }) {
      if (!this.hasPendency) return;
      let response = {};
      try {
        await this.$root.$emit("show-loading");
        response = await this.returnRequestTicket({
          protocol: this.protocol,
          pictures,
          obs
        });
      } finally {
        await this.$root.$emit("hide-loading");
      }

      if (response && response.Data) {
        this.protocolANS = response.Data.protocoloANS;
        this.modalPendencies = false;
        this.openModalSuccess = true;
        const detail = await this.fetchProtocolDetail({
          protocol: this.protocol
        });
        if (detail) {
          this.detail = detail;
        }
      } else {
        await this.$toast({
          description: "Não foi possivel registrar o atendimento.\nServiço temporariamente indisponível.",
          status: "error",
          duration: 10000,
          position: "top"
        });
      }
    },
    async download() {
      const url = await this.getDocumentUrl({ protocol: this.protocol });
      globalThis.window.open(url, "_blank");
    }
  },
  async mounted() {
    try {
      this.$root.$emit("show-loading");
      await this.getDetail();
    } catch (error) {
      console.error(error);
    } finally {
      this.$root.$emit("hide-loading");
    }
  }
};
</script>

<style scoped>
img {
  margin-right: 16px;
}
.pontilhado {
  overflow: auto;
  margin-left: 10px;
  border-left: 1px dashed #8c8c8c;
  margin-bottom: 10px;
}
</style>
